import type { ReactNode } from 'react';

/**
 * NPT-2264 — the always-visible caption over a map pin, so nobody has to guess what a pin is.
 * Never takes pointer events from the map, and stays narrower than a phone-sized map's free width.
 */
export const PinCaption = ({ text }: { text: string }) => (
   <span
      aria-hidden="true"
      data-pin-caption=""
      className="pointer-events-none mb-1 max-w-[min(280px,60vw)] truncate whitespace-nowrap rounded-md bg-white px-2 py-0.5 text-xs font-semibold text-gray-900 shadow ring-1 ring-black/10"
   >
      {text}
   </span>
);

/** A bottom-anchored pin with its caption standing above it. */
export const CaptionedPin = ({ caption, children }: { caption?: string | null; children: ReactNode }) => (
   <div className="flex flex-col items-center">
      {caption && <PinCaption text={caption} />}
      {children}
   </div>
);
